import { FC, useEffect } from 'react';
import { ISelectOptionProps } from 'components/form/types';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import UpdateEntity from 'components/crud/UpdateEntity';
import ElementForm from 'components/elements/components/ElementForm';
import { IElement } from 'components/elements/types';
import { formatDataOnSubmit } from '../dataFormatters';

interface IProps {
  elementsEntityName: string;
  elementsEndpoint: string;
  element: IElement;
  identifierOptions?: ISelectOptionProps[];
}

const EditForm: FC<IProps> = ({ elementsEntityName, elementsEndpoint, element, identifierOptions }: IProps) => {
  const { id, segmentId } = useParams<{ id: string; segmentId: string }>();
  const { showModal } = useModal();
  const { client } = useActiveClientContext();
  const history = useHistory();

  const methods = useForm({
    defaultValues: {
      ...element,
      identifier: identifierOptions?.find(opt => opt.value === element.identifier),
    },
  });

  useEffect(() => {
    if (!identifierOptions?.length) return;
    const matchedOption = identifierOptions.find(opt => opt.value === element.identifier);
    if (matchedOption) {
      methods.setValue('identifier', matchedOption, { shouldValidate: true });
    }
  }, [identifierOptions, element.identifier, methods]);

  return (
    <UpdateEntity
      id={id}
      entity={elementsEndpoint}
      methods={methods}
      onSuccess={(res: any) => {
        const { name, tokens } = res.data;
        const nextPage =
          tokens.length > 0
            ? buildClientUrl(`/segments/${segmentId}/elements/manage-tokens/${id}`, client)
            : buildClientUrl(`/segments/edit/${segmentId}`, client);
        history.push({
          pathname: nextPage,
          state: {
            isEdit: true,
            elementName: name,
          },
        });
        if (!tokens.length)
          showModal({
            type: 'success',
            content: (
              <>
                Редактирахте елемент&nbsp;
                <span className="font-weight-bold">{name}</span>.
              </>
            ),
          });
      }}
      queryKey={[buildClientEntity(elementsEntityName, client), { id }]}
    >
      {(update: any) => {
        return (
          <ElementForm
            methods={methods}
            handleSubmit={data => update(formatDataOnSubmit(data))}
            btnLabel="Запази"
            showBackBtn
            isMultilingual={client?.is_multilingual}
            identifierOptions={identifierOptions}
          />
        );
      }}
    </UpdateEntity>
  );
};

export default EditForm;
